import {
	BellIcon,
	ConversationIcon,
	DialogueIcon,
	GridIcon,
	TargetIcon,
} from '@treams/treams-icons';
import { MomentType } from '@treams/treams-network';

export function MomentIcon({ momentType, size = 20 }: { momentType: MomentType; size?: number }) {
	switch (momentType) {
		case MomentType.Goals:
			return <TargetIcon size={size} />;
		case MomentType.Evaluation:
			return <ConversationIcon size={size} />;
		case MomentType.Feedback:
			return <DialogueIcon size={size} />;
		case MomentType.Message:
			return <BellIcon size={size} />;
		case MomentType.TalentReview:
			return <GridIcon size={size} />;
		default:
			return null;
	}
}
